module.exports = __webpack_public_path__ + "static/media/navBarIconArchive.aa9e2b33.svg";